module.exports = __webpack_public_path__ + "img/img8.e98e08e6.png";